import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalCreditControlService } from "services/ClientPortalCreditControlService";
import { CreditControlDevelopmentSummaryModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  CreditControlDevelopmentSummaries: new Array<CreditControlDevelopmentSummaryModel>(),
  Loading: false,
};

export const CreditControlDevelopmentSummariesSlice = createSlice({
  name: "CreditControlDevelopmentSummaries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditControlDevelopmentSummaries.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCreditControlDevelopmentSummaries.fulfilled, (state, action) => {
        state.CreditControlDevelopmentSummaries = action.payload;
        state.Loading = false;
      })
      .addCase(getCreditControlDevelopmentSummaries.rejected, (state) => {
        state.CreditControlDevelopmentSummaries = new Array<CreditControlDevelopmentSummaryModel>();
        state.Loading = false;
      });
  },
});

export const getCreditControlDevelopmentSummaries = createAsyncThunk<CreditControlDevelopmentSummaryModel[]>(
  "CreditControlDevelopmentSummaries/GetCreditControlDevelopmentSummaries",
  async () => {
    const creditControlService = container.get<IClientPortalCreditControlService>(
      SERVICE_TYPES.CPLClientPortalCreditControlService
    );
    return await creditControlService.getCreditControlDevelopmentSummaries();
  }
);

export const selectCreditControlDevelopmentSummaries = (state: RootState) =>
  state.CreditControlDevelopmentSummaries.CreditControlDevelopmentSummaries;
export const selectLoadingCreditControlDevelopmentSummaries = (state: RootState) =>
  state.CreditControlDevelopmentSummaries.Loading;

export default CreditControlDevelopmentSummariesSlice.reducer;
